<template>
    <div class="sub_container">
      <div class="sub_title">
          <span class="fl">修改密码</span>
          <router-link tag="span" to="/Personal" @click.native="backup">返回上一级</router-link>
      </div>
      <div class="dl">
        <i-form ref= 'formItem' :model="formItem"  :rules='ruleValidate'>
            <form-item label="旧密码" prop='password' >
                <i-input  v-model="formItem.old_pwd" placeholder="请输入旧密码" style="display:none"></i-input>
                <i-input  v-model="formItem.old_pwd" type="password"></i-input>
            </form-item>
            <form-item label="新密码" prop="password" >
                <i-input v-model="formItem.new_pwd" type="password" placeholder="请输入6-18位的新密码" @input='inputChange'></i-input>
            </form-item>
            <form-item label="重复密码" prop="password">
                <i-input v-model="formItem.repeat_pwd" type="password" placeholder="请再次输入新密码"></i-input>
            </form-item>
        </i-form>
        <button class="sub" @click="repeatPwd">确认修改</button>
      </div>
    </div>
</template>

<script>
import doPost from "@/pages/Helper/XHR.js"
import Cookies from 'js-cookie'
export default {
    name: 'changepwd',
    data () {
        var validatePass = function(rule, value, callback) {
            if (value === '') {
                callback(new Error('请输入密码'));
            } else {
                callback();
            }
        }
        var validatePassCheck = function(rule, value, callback){
            if (value === '') {
                return callback(new Error('请再次输入密码'));
            } else if (value !== vue.formItem.password) {
                return callback(new Error('两次密码不一致'));
            } else {
                callback();
            }
        }
        return {
            group:[],
            formItem:{
                old_pwd : "",
                new_pwd : "",
                repeat_pwd : ""
            },
            ruleValidate:{
                new_pwd    : [{validator: validatePass, trigger: 'blur' },{min:6,message:'请输入最少6位'}],
                repeat_pwd   : [{validator: validatePassCheck, trigger: 'blur' },{min:6,message:'请输入最少6位'}]
            }
        }
    },
    methods: {
        backup () {
            this.$store.commit('changeSub',false)
        },
        repeatPwd () {
            if(this.formItem.new_pwd.length<6||this.formItem.new_pwd.length>18){
                this.$Message.error('新密码的长度应该大于6位小于18位')
                return
            }            
            if(this.formItem.new_pwd!==this.formItem.repeat_pwd){
                this.$Message.error('新密码与重复密码不一致')
                return
            }
            let session = localStorage.session
            // let username = localStorage.getItem("username")
            let username = Cookies.get("username")
            // let session = Cookies.get("session")
            doPost(
                {action: "reset_pwd", username: username, old_password: this.formItem.old_pwd, new_password: this.formItem.new_pwd, new_password_cf: this.formItem.repeat_pwd, session: session, web: 'pc'},
                (res) =>{
                    
                    if(!res.status){
                        this.$Message.success(res.detail)
                        setTimeout(()=>{
                            this.$store.commit('changeLogin',false)
                            //退出时将从缓存中移除 用户session 登录状态LoginStatus 用户名存储
                            localStorage.removeItem("session")
                            localStorage.removeItem("LoginStatus")
                            localStorage.removeItem("user_name")
                            Cookies.remove("session")
                            Cookies.remove("LoginStatus")
                            Cookies.remove("user_name")
                            window.location.href='/resource/login/';//2020-7-17改
                            // this.$router.push('/Personal')
                            // this.backup()
                        },300)
                    }else{
                        this.$Message.error(res.detail)
                    }
                }
            )
        },
        inputChange(e){
            let reg=/\s/g;
            if(reg.test(this.formItem.new_pwd)){
                this.$Message.error('密码中不能含有空格字符')
                this.formItem.new_pwd='';
                this.$forceUpdate()
            }
            console.log(this.formItem.new_pwd);
        }
    }

}
</script>

<style lang="stylus" scoped>
.sub_container
    padding 20px 30px
    text-align center
.sub_title span:nth-child(2)
    float right
.sub_container .sub
    width 177px
    line-height 36px
    background #2BD3A0
    border 1px solid #2BD3A0
    border-radius 100px
    color #ffffff
    padding  0px 20px
    // margin-left 90px
    font-weight bold
>>> .ivu-form
    padding 20px 10px
>>> .ivu-form-item-label
    margin-right 10px
    width 60px
    text-align left
>>> .ivu-input-wrapper
    display inline
>>> .ivu-input
    display inline-block
    width 300px
</style>





// WEBPACK FOOTER //
// src/pages/Personal/components/changepwd.vue